export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Preferences-Gray-9760b766ad2b0779341ead91cae857c6.svg";